export default __webpack_public_path__ + "static/media/SFProDisplay-Black.b06be182.woff2";